<template>
    <div class="living">
        <h3 class="live-top flex flex-vertical-center">
            <span class="live-top-title">{{ date }}</span>
            <span class="live-top-time">{{ week }}</span>
        </h3>
        <div class="live-container flex">
            <div class="living-time">
                <p class="start-time">{{ startTime(data.live_start_time) }}</p>
            </div>
            <div class="living-content">
                <div class="content">
                    <div class="flex flex-between">
                        <div class="flex flex-column">
                            <p class="subject">{{ baseData.name }}</p>
                            <span class="teacher">{{
                                `授课老师：${baseData.teacher_name} / 科目：【${baseData.subject_name}】`
                            }}</span>
                        </div>
                        <div class="btn-group flex">
                            <hk-button
                                v-if="doTestStatus"
                                text="做作业"
                                :customStyle="buttonStyle2"
                                @handleClick="toTest(baseData.id)"
                            ></hk-button>
                            <hk-button
                                v-if="baseData.work_status > 0"
                                text="查看解析"
                                :customStyle="buttonStyle"
                                @handleClick="toAnalysis(baseData.id)"
                            ></hk-button>
                            <hk-button
                                v-if="!data.expired"
                                text="取消预约"
                                :customStyle="buttonStyle3"
                                @handleClick="cancelSubcribe"
                            ></hk-button>
                            <hk-button
                                v-if="livingBtnStatus"
                                :text="buttonText"
                                :customStyle="{ ...buttonStyle, ...disabledStyle }"
                                @handleClick="toLiving"
                            ></hk-button>
                        </div>
                    </div>
                    <el-collapse v-model="activeNames" @change="handleChange">
                        <el-collapse-item name="1">
                            <template #title>
                                <span class="subscribe-count"
                                    >{{ getReserveCount(baseData.lives.data) }}人 预约</span
                                >
                                <p class="change-time flex flex-vertical-center">
                                    修改时间<i
                                        :class="[{ up: arrowUp }, 'el-icon-arrow-down', 'arrow']"
                                    ></i>
                                </p>
                            </template>
                            <ul class="flex flex-start flex-vertical-center flex-wrap">
                                <li
                                    v-for="(item, index) in liveRoomList"
                                    :key="index"
                                    :class="[
                                        {
                                            subscribed: item.am_i_reserved,
                                            manFull:
                                                item.reserve_count === item.max_reserve ||
                                                item.expired,
                                            notAllow: disabled
                                        },
                                        'times-item'
                                    ]"
                                    @click="changeTimes(item)"
                                >
                                    <p class="times">
                                        {{ startTime(item.live_start_time) }}
                                    </p>
                                    <p class="person-count">
                                        {{
                                            item.reserve_count === item.max_reserve
                                                ? '已满员'
                                                : `${item.reserve_count} / ${item.max_reserve} 人`
                                        }}
                                    </p>
                                    <span v-if="item.am_i_reserved" class="choose"></span>
                                </li>
                            </ul>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
        <hk-dialog
            :state.sync="dialogCancelState"
            :title="dialogCancelTitle"
            buttonText="确认取消"
            @close="closeCancelDialog"
            @confirm="confirmCancel"
        >
            <template #content>
                <div class="change-times-slot">
                    <p class="lesson-content">
                        {{ baseData.name }}
                    </p>
                    <p class="lesson-content">
                        {{
                            `授课老师：${baseData.teacher_name} / 科目：【${baseData.subject_name}】`
                        }}
                    </p>
                    <div class="change-times-content flex flex-center">
                        <div class="times old-times flex flex-column flex-center">
                            <h4 class="time">{{ startTime(data.live_start_time) }}</h4>
                            <p class="date">{{ getDate(data.live_start_time) }}</p>
                        </div>
                    </div>
                </div>
            </template>
        </hk-dialog>
        <hk-dialog
            :state.sync="dialogState"
            :title="dialogTitle"
            buttonText="确认修改"
            @close="closeDialog"
            @confirm="confirm"
        >
            <template #content>
                <div class="change-times-slot">
                    <p class="lesson-content">
                        {{ baseData.name }}
                    </p>
                    <p class="lesson-content">
                        {{
                            `授课老师：${baseData.teacher_name} / 科目：【${baseData.subject_name}】`
                        }}
                    </p>
                    <div class="change-times-content flex flex-between">
                        <div class="times old-times flex flex-column flex-center">
                            <img class="times-bg" src="@images/base/old-times-bg.png" alt="" />
                            <h4 class="time">{{ startTime(data.live_start_time) }}</h4>
                            <p class="date">{{ getDate(data.live_start_time) }}</p>
                        </div>
                        <div class="times new-times flex flex-column flex-center">
                            <img class="times-bg" src="@images/base/new-times-bg.png" alt="" />
                            <h4 class="time">{{ startTime(newTimes.live_start_time) }}</h4>
                            <p class="date">{{ getDate(newTimes.live_start_time) }}</p>
                        </div>
                    </div>
                </div>
            </template>
        </hk-dialog>
    </div>
</template>

<script>
import moment from '@plugins/_moment';
import HkButton from '@components/HkButton';
import HkDialog from '@components/HkDialog';
import { cancelSubcribeLive, changeSubcribeLive } from '@api/liveList';
export default {
    name: 'Subscribe',
    components: {
        HkButton,
        HkDialog
    },
    props: {
        data: {
            require: true,
            type: Object
        },
        baseData: {
            require: true,
            type: Object
        }
    },
    data() {
        return {
            buttonStyle: {
                width: '110px',
                color: '#6D33B3',
                border: '1px solid #6D33B3',
                shadowColor: 'transparent',
                background: false,
                startColor: 'transparent',
                endColor: 'transparent'
            },
            buttonStyle2: {
                width: '110px',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            },
            buttonStyle3: {
                width: '110px',
                color: '#666666',
                border: '1px solid #aaa',
                background: false,
                shadowColor: 'transparent',
                startColor: '#D7D7D7',
                endColor: '#D7D7D7'
            },
            activeNames: '',
            arrowUp: false,
            dialogTitle: '确定要修改预约时间么？',
            dialogCancelTitle: '确定要取消预约么？',
            newTimes: {},
            dialogState: false,
            dialogCancelState: false,
            buttonText: '进入直播'
        };
    },

    computed: {
        date() {
            const time = this.baseData.show_time;
            const now = moment().locale('zh-cn').format('YYYY-MM-DD HH:mm:ss');
            const weekTime = moment(time).format('YYYY-MM-DD HH:mm:ss');
            if (now === weekTime) {
                return '今日课程';
            }
            return moment(time).format('MM月DD日');
        },
        week() {
            const showTime = this.baseData.show_time;
            const momentTime = moment(showTime);
            return momentTime.format('dddd');
        },
        endTime() {
            const time = this.data.live_end_time;
            return moment(time).format('HH:mm');
        },
        doTestStatus() {
            const { baseData, data } = this;
            if (
                baseData.work_id > 0 &&
                !baseData.work_status &&
                data.am_i_reserved &&
                data.live_end_time
            ) {
                return true;
            }
            return false;
        },
        livingBtnStatus() {
            const { data } = this;
            if (data.status > 0) {
                return true;
            }
            return false;
        },
        liveRoomList() {
            if (!Array.isArray(this.baseData.lives.data)) {
                return [];
            }
            return this.baseData.lives.data.sort((a, b) => {
                const aDate = moment(a.live_start_time);
                const bDate = moment(b.live_start_time);
                if (aDate.isBefore(bDate)) {
                    return -1;
                } else if (aDate.isSame(bDate)) {
                    return 0;
                } else {
                    return 1;
                }
            });
        },
        disabled() {
            return this.baseData.lives.data.some((item) => item.am_i_reserved && item.expired);
        },
        disabledStyle() {
            const disabled = this.disabled;
            return disabled
                ? {
                      shadowColor: 'transparent',
                      startColor: '#D7D7D7',
                      endColor: '#D7D7D7'
                  }
                : {};
        }
    },

    created() {},

    methods: {
        startTime(time) {
            const interimTime = time;
            return moment(interimTime).format('M月D日 H:mm');
        },
        getDate(time) {
            const date = time;
            return moment(date).format('MM月DD日 dddd');
        },
        handleChange() {
            this.arrowUp = !this.arrowUp;
        },
        changeTimes(item) {
            if (
                item.am_i_reserved ||
                item.reserve_count >= item.max_reserve ||
                item.expired ||
                this.disabled
            ) {
                return;
            }
            this.newTimes = item;
            this.dialogState = true;
        },
        cancelSubcribe() {
            this.dialogCancelState = true;
        },
        closeDialog() {
            this.dialogState = false;
        },
        confirm() {
            const { newTimes, disabled } = this;
            if (disabled) {
                return;
            }
            this.$trackEvent('直播', '修改预约', newTimes.id);
            changeSubcribeLive({
                schedule_id: newTimes.schedule_id,
                live_id: newTimes.id
            }).then((res) => {
                this.$message({
                    message: '预约成功',
                    type: 'success'
                });
                this.$store.dispatch('queryLiveList');
                this.dialogState = false;
            });
        },
        closeCancelDialog() {
            this.dialogCancelState = false;
        },
        confirmCancel() {
            const { data, disabled } = this;
            if (disabled) {
                return;
            }
            this.$trackEvent('直播', '取消预约', data.id);
            cancelSubcribeLive(data.schedule_id).then((res) => {
                this.$message({
                    message: '取消预约成功',
                    type: 'success'
                });
                this.$store.dispatch('queryLiveList');
                this.dialogCancelState = false;
            });
        },
        toLiving() {
            // const { disabled } = this;
            // if (disabled) {
            //     return;
            // }
            const { href } = this.$router.resolve({
                name: 'Video',
                query: { id: this.data.id, scheduleId: this.data.schedule_id }
            });
            this.$trackEvent('直播', '进入直播', this.data.id);
            window.open(href, '_blank');
        },
        toTest(id) {
            this.$trackEvent('答题', '开始做题', id);
            this.$router.push({ name: 'Test', query: { scheduleId: id } });
        },
        toAnalysis(id) {
            this.$trackEvent('答题', '解析', id);
            this.$router.push({ name: 'Analysis', query: { scheduleId: id } });
        },
        getReserveCount(lives = []) {
            return lives.reduce((prev, current) => {
                if (current.reserve_count) {
                    return prev + Number(current.reserve_count);
                }
                return prev;
            }, 0);
        }
    }
};
</script>
<style lang="scss" scoped>
.living {
    width: 100%;
    .live-top {
        margin-bottom: 13px;
        span {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333;
        }
        .live-top-title {
            margin-right: 30px;
        }
    }
    .live-container {
        align-items: flex-start;
        .living-time {
            margin-right: 52px;
            margin-top: 2px;
            width: 78px;
            .start-time {
                font-size: 15px;
                font-weight: 800;
                color: #333;
                margin-bottom: 8px;
            }
            .end-time {
                font-size: 12px;
                font-weight: 500;
                color: #666;
            }
        }
        .living-content {
            width: calc(100% - 126px);
            padding-left: 12px;
            border-left: 1px solid #e5e5e5;
            .content {
                box-sizing: border-box;
                width: 100%;
                border-radius: 20px;
                background-color: #f9f9f9;
                padding: 20px 20px 20px 36px;
                .btn-group {
                    .hk-button {
                        margin-left: 10px;
                    }
                }
                .subject {
                    font-size: 16px;
                    font-weight: 800;
                    color: #333;
                    margin-bottom: 14px;
                }
                .teacher {
                    font-size: 14px;
                    font-weight: 500;
                    color: #666;
                    margin-bottom: 14px;
                }
                .subscribe-count {
                    font-size: 14px;
                    font-weight: 500;
                    color: #666;
                }
                .change-time {
                    font-size: 14px;
                    font-weight: 500;
                    color: #6d33b3;
                    .arrow {
                        color: #6d33b3;
                        font-weight: bold;
                        margin-left: 5px;
                        transition: transform 0.5s;
                    }
                    .up {
                        transform: rotate(180deg);
                    }
                }
                &::v-deep {
                    .el-collapse {
                        box-sizing: border-box;
                        width: 100%;
                        border: none;
                    }
                    .el-collapse-item {
                        box-sizing: border-box;
                        width: 100%;
                        background: transparent;
                    }
                    .el-collapse-item__header {
                        border: none;
                        background-color: transparent;
                        justify-content: space-between;
                        height: auto;
                        line-height: 0;
                    }
                    .el-collapse-item__wrap {
                        border: none;
                        background-color: transparent;
                    }
                    .el-collapse-item__arrow {
                        display: none;
                    }
                    .el-collapse-item__content {
                        padding-bottom: 0;
                        line-height: 1;
                        .times-item {
                            box-sizing: border-box;
                            width: 128px;
                            height: 56px;
                            background: #f3f5fa;
                            border: 1px solid #cacbcd;
                            border-radius: 4px;
                            padding: 10px 15px;
                            cursor: pointer;
                            position: relative;
                            margin-top: 13px;
                            .times {
                                font-size: 14px;
                                font-weight: 500;
                                color: #333;
                                margin-bottom: 8px;
                            }
                            .person-count {
                                font-size: 12px;
                                font-weight: 400;
                                color: #333;
                            }
                        }
                        .subscribed {
                            background: #6d33b3;
                            border: 1px solid #6d33b3;
                            cursor: default;
                            .times {
                                color: #fff;
                            }
                            .person-count {
                                color: #fff;
                            }
                            .choose {
                                width: 20px;
                                height: 20px;
                                background: url('~@images/base/right-purple.png') no-repeat center
                                    #fff;
                                border: 1px solid #6d33b3;
                                border-radius: 4px;
                                position: absolute;
                                top: 0;
                                right: 0;
                            }
                        }
                        .manFull {
                            background: #f3f5fa;
                            border: 1px solid #cacbcd;
                            cursor: not-allowed;
                            .times {
                                color: #999;
                            }
                            .person-count {
                                color: #999;
                            }
                            .choose {
                                width: 20px;
                                height: 20px;
                                background-color: #f3f5fa;
                                border: 1px solid #cacbcd;
                                border-radius: 4px;
                                position: absolute;
                                top: 0;
                                right: 0;
                            }
                        }
                        .notAllow {
                            cursor: not-allowed;
                        }
                        .times-item:not(:last-child) {
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }
    .change-times-slot {
        width: 416px;
        margin-bottom: 20px;
        .lesson-content {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999;
            margin-bottom: 14px;
        }
        .change-times-content {
            width: 100%;
            background: url('~@images/base/change-icon.png') no-repeat center;
            .times {
                box-sizing: border-box;
                width: 181px;
                height: 77px;
                background: #f9f9f9;
                border-radius: 20px;
                position: relative;
                .time {
                    font-size: 18px;
                    font-family: PingFangSC;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 5px;
                }
                .date {
                    font-size: 14px;
                    font-family: PingFangSC;
                    font-weight: 400;
                    color: #666;
                }
                .times-bg {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                }
            }
        }
    }
}
</style>
